import { gql } from "@apollo/client";
import SearchableQuerySelector from "components/shared/SearchableQuerySelector";

const FETCH_STOCK_CATEGROIES = gql`
  query FETCH_STOCK_CATEGROIES {
    stockCategories {
      id
      name
    }
  }
`;

const sortCustomers = (customers = []) => {
  const isChinese = (str) => /[\u3400-\u9FBF]/.test(str || "");

  return [...customers].sort((a, b) => {
    const aIsChinese = isChinese(a.name);
    const bIsChinese = isChinese(b.name);
    if (aIsChinese && !bIsChinese) return -1;
    if (!aIsChinese && bIsChinese) return 1;
    return a.name.localeCompare(b.name);
  });
};

const InlineStockCategorySelector = ({
  query = FETCH_STOCK_CATEGROIES,
  valueView,
  optionView = (customer) => <div>{customer.name}</div>,
  onChange,
  disabled,
  autoFocus,
  className = "",
}) => {
  return (
    <SearchableQuerySelector
      className={className}
      query={query}
      queryVariables={{}}
      buildQueryVariables={() => ({})}
      resolveOptions={(data, { searchText }) =>
        sortCustomers(data?.stockCategories || []).filter((i) => {
          if (!searchText) return true;
          const keyword = searchText.toLowerCase();
          return i.name?.toLowerCase().includes(keyword);
        })
      }
      optionView={optionView}
      valueView={valueView}
      onSelect={onChange}
      disabled={disabled}
      placeholder="Select a stock category"
      loadingText="Loading stock categories..."
      emptyText="No stock category found"
      fetchPolicy="network-only"
      autoFocus={autoFocus}
    />
  );
};

export default InlineStockCategorySelector;
